/* istanbul ignore file */
import { Text, CardContainer, constants } from '@adc/ui-adc'
import classNames from 'classnames/bind'
import sarahSuccessIcon from '../../../../assets/sarah_success_icon.png'
import mikeSuccessIcon from '../../../../assets/mike_success_icon.png'
import lisaSuccessIcon from '../../../../assets/lisa_success_icon.png'
import starIcon from '../../../../assets/star_icon.svg'
import styles from './styles.scss'

const cx = classNames.bind(styles)
const { ColorNames } = constants

const WhatSellersSay = () => {
  const testimonials = [
    {
      icon: sarahSuccessIcon,
      location: 'Dallas, TX',
      name: 'Sarah M.',
      comment:
        '"The auction process was transparent and competitive. I got 15% more than I expected and closed in just 28 days."',
    },
    {
      icon: mikeSuccessIcon,
      location: 'Phoenix, AZ',
      name: 'Mike R.',
      comment:
        '"SmartSale gave me the privacy I needed. Professional buyers, smooth process, and I had complete control."',
    },
    {
      icon: lisaSuccessIcon,
      location: 'Miami, FL',
      name: 'Lisa K.',
      comment:
        '"After trying traditional listing for 6 months, Auction.com sold my property in 3 weeks. Incredible results!"',
    },
  ]

  return (
    <div>
      <div className={cx('landing-section', 'testimonials-section')}>
        <div className={cx('testimonials-header-section')}>
          <Text.Header as='h1'>What Our Sellers Say</Text.Header>

          <Text size='large' style={{ lineHeight: '28px' }}>
            Real stories from property owners who chose Auction.com
          </Text>
        </div>
        <div className={cx('testimonials-container')}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className={cx('testimonial-column')}>
              <CardContainer
                className={cx('testimonial-card')}
                borderColor={ColorNames.InfoLight}
                borderRadius='medium'
                borderStyle='line'
                borderRadiusCorners='all'
                style={{
                  background: 'linear-gradient(90deg, #F0FBFE 0%, #FFF 100%)',
                }}
              >
                <div className={cx('testimonial-content')}>
                  <div className={cx('testimonial-header')}>
                    <img
                      src={testimonial.icon}
                      alt={testimonial.name}
                      className={cx('testimonial-icon')}
                    />
                    <div className={cx('testimonial-info')}>
                      <Text
                        size='small'
                        weight='medium'
                        style={{ lineHeight: '24px' }}
                      >
                        {testimonial.name}
                      </Text>
                      <Text
                        size='tiny'
                        color={ColorNames.Gray}
                        weight='normal'
                        style={{ lineHeight: '20px' }}
                      >
                        {testimonial.location}
                      </Text>
                    </div>
                  </div>
                  <Text
                    as='p'
                    size='small'
                    weight='medium'
                    className={cx('testimonial-comment')}
                  >
                    {testimonial.comment}
                  </Text>
                  <div className={cx('testimonial-stars')}>
                    {Array.from({ length: 5 }, (_, index) => (
                      <img
                        key={index}
                        src={starIcon}
                        alt='star'
                        className={cx('star-icon')}
                      />
                    ))}
                  </div>
                </div>
              </CardContainer>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default WhatSellersSay
